
'use strict';
import '@fancyapps/fancybox';
const $ = jQuery.noConflict();

// set by initReels(); stops whichever reel is currently playing inline
let stopActiveReel = function() {};

$(function() {
	initMediaTabs();
	initReels();
});

// tabs: Video / Articles / Reels
function initMediaTabs() {
	const $tabsWrap = $('.js-media-tabs');
	const $tabs = $tabsWrap.find('.media__tab');
	const panelsMap = {
		video: $('.js-video-panel'),
		articles: $('.js-articles-panel'),
		reels: $('.js-reels-panel'),
	};

	if (!$tabsWrap.length || !$tabs.length) {
		return;
	}

	let $activeTab = $tabs.filter('.is-active').first();
	if (!$activeTab.length) {
		$activeTab = $tabs.first();
	}
	let activeKey = $activeTab.data('tab');

	// position the sliding pill indicator behind the given tab button
	function moveIndicator($tab) {
		if (!$tab || !$tab.length) {
			return;
		}
		const inset = 6; // small cosmetic gap between the pill and the tab edges
		const wrapOffset = $tabsWrap.offset();
		const tabOffset = $tab.offset();
		const left = (tabOffset.left - wrapOffset.left) + inset;
		const width = Math.max(0, $tab.outerWidth() - (inset * 2));

		$tabsWrap.css({
			'--media-indicator-x': left + 'px',
			'--media-indicator-width': width + 'px',
		});
	}

	// init indicator position once layout is ready
	moveIndicator($activeTab);
	$(window).on('resize', function() {
		moveIndicator($tabs.filter('[data-tab="' + activeKey + '"]'));
	});

	$tabs.on('click', function(e) {
		e.preventDefault();
		const $tab = $(this);
		const key = $tab.data('tab');

		if (key === activeKey) {
			return; // već aktivan
		}

		const $currentPanel = panelsMap[activeKey];
		const $nextPanel = panelsMap[key];

		$tabs.removeClass('is-active');
		$tab.addClass('is-active');
		moveIndicator($tab);

		// leaving the Reels tab: stop whichever reel is playing inline
		if (activeKey === 'reels') {
			stopActiveReel();
		}
		activeKey = key;

		if ($currentPanel && $currentPanel.length) {
			$currentPanel.stop(true, true).fadeOut(400, function() {
				if ($nextPanel && $nextPanel.length) {
					$nextPanel.stop(true, true).fadeIn(400);
				}
			});
		} else if ($nextPanel && $nextPanel.length) {
			$nextPanel.stop(true, true).fadeIn(400);
		}
	});
}

// reels: play/pause inline in the grid instead of opening a lightbox popup.
// clicking a reel starts it, clicking it again stops it, and starting a different
// reel automatically stops whichever one was playing.
function initReels() {
	const $triggers = $('.js-reel-trigger');
	if (!$triggers.length) {
		return;
	}

	let $active = null;

	function resetReel($trigger) {
		if (!$trigger || !$trigger.length) {
			return;
		}
		const $wrap = $trigger.find('.js-reel-media-wrap');
		const $video = $wrap.data('reel-video');
		if ($video) {
			$video[0].pause();
			$video.remove();
			$wrap.removeData('reel-video');
		}
		$wrap.find('.js-reel-iframe').remove();
		$wrap.removeClass('is-playing');
	}

	function playReel($trigger) {
		const $wrap = $trigger.find('.js-reel-media-wrap');
		const source = $trigger.data('reel-source');
		const src = $trigger.data('reel-src');
		if (!src || src === '#') {
			return;
		}

		$wrap.addClass('is-playing');

		if (source === 'upload') {
			const $video = $('<video class="media__panel-item-video" playsinline></video>').attr('src', src);
			$wrap.append($video);
			$wrap.data('reel-video', $video);

			$video.on('ended', function() {
				resetReel($trigger);
				$active = null;
			});

			const playPromise = $video[0].play();
			if (playPromise && typeof playPromise.catch === 'function') {
				playPromise.catch(function() {});
			}
		} else {
			const separator = src.indexOf('?') === -1 ? '?' : '&';
			const $iframe = $('<iframe class="media__panel-item-video js-reel-iframe" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>')
				.attr('src', src + separator + 'autoplay=1');
			$wrap.append($iframe);
		}

		$active = $trigger;
	}

	stopActiveReel = function() {
		if ($active) {
			resetReel($active);
			$active = null;
		}
	};

	$triggers.on('click', function(e) {
		e.preventDefault();
		const $trigger = $(this);

		if ($active && $active.is($trigger)) {
			resetReel($trigger);
			$active = null;
			return;
		}

		if ($active) {
			resetReel($active);
		}

		playReel($trigger);
	});
}
